/*
 * @Author: Teemo Ding
 * @Date: 2021-12-01 11:57:07
 * @LastEditTime: 2022-03-18 14:34:46
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerList/Components/AdvancedFilter/tools.ts
 */
import { transferDataFromForm } from 'src/constrains/AdvancedFilters/Components/OrderAmount';

export const convertDataFromState = (conditions: any) => {
  const {
    abandonCheckoutFilter,
    consentAttributeFilter,
    discountFilter,
    orderAmountFilter,
    orderCountFilter,
    orderDateFilter,
    productPurchasedFilter,
    registerDateFilter,
    registeredSalesChannelFilter,
    shoppingCartFilter,
    subscriptionFilter,
    languageFilter,
    tagFilter,
    ...rest
  } = conditions || {};
  const reConditions = { ...rest };

  const { selectedLanguages } = languageFilter || {};
  if ((selectedLanguages || []).length > 0) {
    reConditions.languageFilter = languageFilter;
  }

  const { abandonedCheckout } = abandonCheckoutFilter || {};
  if (abandonedCheckout) {
    reConditions.abandonCheckoutFilter = abandonCheckoutFilter;
  }

  const { include: consentAttributeFilterInclude } =
    consentAttributeFilter || {};
  if (consentAttributeFilterInclude) {
    reConditions.consentAttributeFilter = consentAttributeFilter;
  }

  const { include: discountFilterInclude } = discountFilter || {};
  if (discountFilterInclude) {
    reConditions.discountFilter = discountFilter;
  }

  const { policy: discountFilterPolicy } = orderAmountFilter || {};
  if (discountFilterPolicy) {
    reConditions.orderAmountFilter = orderAmountFilter;
  }

  const { orderStatus } = orderCountFilter || {};
  if (orderStatus) {
    const _orderStatus = transferDataFromForm(orderCountFilter);
    reConditions.orderCountFilter = {
      ...orderCountFilter,
      orderStatus: _orderStatus,
    };
  }

  const { searchCondition } = orderDateFilter || {};
  if (searchCondition) {
    reConditions.orderDateFilter = orderDateFilter;
  }

  const { include: productPurchasedFilterInclude } =
    productPurchasedFilter || {};
  if (productPurchasedFilterInclude) {
    reConditions.productPurchasedFilter = productPurchasedFilter;
  }

  const { registered } = registerDateFilter || {};

  if (registered) {
    reConditions.registerDateFilter = registerDateFilter;
  }

  const { policy: registeredSalesChannelFilterPolicy } =
    registeredSalesChannelFilter || {};
  if (registeredSalesChannelFilterPolicy) {
    reConditions.registeredSalesChannelFilter = registeredSalesChannelFilter;
  }

  const { include: shoppingCartFilterInclude } = shoppingCartFilter || {};
  if (shoppingCartFilterInclude) {
    reConditions.shoppingCartFilter = shoppingCartFilter;
  }

  const { subscribed } = subscriptionFilter || {};
  if (subscribed) {
    reConditions.subscriptionFilter = subscriptionFilter;
  }

  const { include: tagInclude } = tagFilter || {};
  if (tagInclude) {
    reConditions.tagFilter = tagFilter;
  }

  return reConditions;
};
